import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { Room } from "shared/types/Room"
import { WithClassName } from "shared/types/WithClassName"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import "./styles/_room-title.scss"

export interface RoomTitleProps extends WithClassName {
  room: Pick<Room, "label" | "number" | "hasClarificationRequest">
  showClarificationRequestIndicator?: boolean
}

export function formatRoomTitle(
  number: string | null | undefined,
  label: string | null | undefined
) {
  if (!number || !label) {
    return number || label || ""
  }
  return `${number} | ${label}`
}

export const RoomTitle = React.memo(
  ({
    className,
    room: { label, number, hasClarificationRequest },
    showClarificationRequestIndicator
  }: RoomTitleProps) => {
    const { t } = useTranslation()

    return (
      <div className={classNames("room-title", className)}>
        <Icon name={IconName.ROOM} className="room-title__icon" />
        <span className="room-title__text">
          {formatRoomTitle(number, label)}
        </span>
        {showClarificationRequestIndicator && hasClarificationRequest ? (
          <div className="room-title__cr-indicator">
            <span className="visually-hidden">
              {t("ClarificationRequest.Indicator")}
            </span>
            <Icon name={IconName.CLARIFICATION_REQUEST} />
          </div>
        ) : null}
      </div>
    )
  }
)
